/**
 * Author: postcodex
 * Date: 10/13/20
 * Time: 10:08 PM
 */
__webpack_public_path__ = `${ postcodexLookupObj.publicPath }/`;
import { debounce } from 'lodash';
import { apiRequest } from '../../api';
import style from './style.scss';

( function ( $ ) {
	'use strict';

	const pl = {
		init : () => {
			document.getElementById( 'api_key' ).addEventListener( 'keyup', pl.apiKeyChange );

			pl.initColorPicker();
		},

		initColorPicker : () => {
			$( '.pl-color-picker' ).wpColorPicker();
		},

		debounceApiKeyChange : debounce( ( apiKey ) => {
			const input = document.getElementById( 'api_key' );
			let mark = document.getElementById( 'api-key-validity' );
			if ( !mark ) {
				mark = document.createElement( 'span' );
			}
			mark.id = 'api-key-validity';
			mark.style.cssText = 'display: inline-block; vertical-align: middle; margin: 0.4em; font-style: italic;';
			mark.innerHTML = 'verifying...';
			input.parentNode.insertBefore( mark, input.nextSibling );

			apiRequest( {
				ep     : 'validate-api-token',
				method : 'GET',
				apiKey
			} ).then( ( { data, error } ) => {
				if ( data ) {
					const { is_valid } = data;

					mark.style.fontStyle = 'normal';
					if ( is_valid ) {
						mark.innerHTML = '&#10004;';
						mark.style.color = 'green';
						mark.title = 'API key is valid.';
					} else {
						mark.innerHTML = '&#10006;';
						mark.style.color = 'red';
						mark.title = 'API key is invalid.';
					}
					input.parentNode.insertBefore( mark, input.nextSibling );
				} else {
					const { message } = error;
					alert( message );
				}
			} );
		}, 700 ),

		apiKeyChange : ( e ) => {
			if ( 2 < e.target.value.trim().length ) {
				pl.debounceApiKeyChange( e.target.value );
			}
		},
	};

	pl.init();
} )( jQuery );
